import { Component, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { SystemMessageComponent } from './components/shared/system-message/system-message.component';
import { OfflineDbService } from './shared/services/offline-db.service';
import { CapacitorService } from './shared/services/capacitor.service';
import { ApiService } from './services/api.service';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent, SystemMessageComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('frontend');
  public dbReady = signal(true); // Standard: true für Web
  public dbError = signal<string | null>(null);

  constructor(
    private offlineDb: OfflineDbService,
    private api: ApiService,
    private capacitorService: CapacitorService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.themeService.init();
    this.initializeCapacitor();
    // Nur auf nativen Geräten auf DB-Initialisierung warten
    if (this.capacitorService.isNativeApp()) {
      this.dbReady.set(false);
      this.dbError.set(null);
      this.offlineDb.dbReadyPromise.then(() => {
        this.dbReady.set(true);
        this.offlineDb.setupSyncOnReconnect(this.api);
      }).catch((err) => {
        this.dbError.set('Fehler bei der Initialisierung der Offline-Datenbank: ' + (err?.message || err));
        this.dbReady.set(true); // Dashboard trotzdem anzeigen
      });
    } else {
      this.dbReady.set(true);
      this.offlineDb.setupSyncOnReconnect(this.api);
    }
  }

  private initializeCapacitor(): void {
    // Initialize Capacitor app on native platforms
    if (typeof window !== 'undefined' && typeof (window as any).Capacitor !== 'undefined') {
      const Capacitor = (window as any).Capacitor;
      const App = Capacitor?.App;

      if (App && App.ready) {
        App.ready()
          .then(() => {
            console.log('Capacitor App ready');
            // Hide splash screen after app is ready
            if (App.hideSplashScreen) {
              App.hideSplashScreen().catch(() => {
                // Splash screen might not exist
              });
            }
          })
          .catch((error: any) => {
            console.warn('Capacitor initialization warning:', error);
          });
      }
    }
  }
}
